import { useHealth } from '@/hooks/use-health';
import { AlertTriangle } from 'lucide-react';

/**
 * Banner amarelo no topo do AppShell quando `META_CLOUD_MODE=mock` em prod.
 * Avisa que mensagens WhatsApp **não** saem para o Meta — fluxos passam por
 * cliente mock determinístico. Visível pra qualquer user logado, fica até
 * admin trocar pra `real` (precisa BM aprovada + permission).
 */
export function DemoModeBanner() {
  const { data } = useHealth();
  if (!data || data.metaCloudMode !== 'mock') return null;

  return (
    <div className="flex items-center gap-2 border-b border-amber-300 bg-amber-50 px-6 py-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        <strong>Demo mode ativo</strong> — mensagens WhatsApp não são enviadas para o Meta.
        Configure{' '}
        <code className="rounded bg-amber-100 px-1 py-0.5 dark:bg-amber-900/60">
          META_CLOUD_MODE=real
        </code>{' '}
        no servidor pra ativar envio real (requer Business Manager aprovado pelo Meta).
      </span>
    </div>
  );
}
